var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWalletGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9828 9.88044H17.0756V12.4614H13.9828C13.3256 12.4614 12.7899 11.8818 12.7899 11.1709C12.7899 10.46 13.3256 9.88044 13.9828 9.88044Z",
    fill: "#1BA929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2185 2.6709H3.50419C2.32561 2.6709 1.36133 3.71408 1.36133 4.98908V17.3527C1.36133 18.6277 2.32561 19.6709 3.50419 19.6709H19.2185C20.397 19.6709 21.3613 18.6277 21.3613 17.3527V4.98908C21.3613 3.71408 20.397 2.6709 19.2185 2.6709ZM18.5042 13.2341C18.5042 13.6591 18.1828 14.0068 17.7899 14.0068H13.9828C12.5328 14.0068 11.3613 12.7318 11.3613 11.1709C11.3613 9.60999 12.5328 8.33499 13.9828 8.33499H17.7899C18.1828 8.33499 18.5042 8.68272 18.5042 9.10772V13.2341Z",
    fill: "#1BA929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletGreen);
export default __webpack_public_path__ + "static/media/icon_wallet_green.4e7d047b393ad29f2b7cff1dcce9af67.svg";
export { ForwardRef as ReactComponent };